import { createStore } from 'vuex';
import user from './user';
import exam from './exam';
import question from './question';
import score from './score';

export default createStore({
  modules: {
    user,
    exam,
    question,
    score
  }
});